import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormBuilderClassicRoute: InvariantJiraRoute = {
	name: 'software-form-builder-classic',
	path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
	exact: true,
};
